const RulesComponent = require.context('./modules', true, /\.js$/);

/** 做一个集合 */
const modules = {};

RulesComponent.keys().forEach(item=>{
    Object.assign(modules,RulesComponent(item))
})
export default modules

